import { useEffect, useState, useCallback } from "react";
import Layout from "../../components/global/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import CardSkeleton from "../../components/global/card/CardSkeleton/CardSkeleton";
import CardBook from "../../components/global/card/CardBook/CardBook";
import Paginator from "react-hooks-paginator";

const HasilPenilaian = () => {
  const [loading, setLoading] = useState(false);
  const [books, setBooks] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const pageLimit = 9;
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [filters, setFilters] = useState({
    type: "btp",
    title: "",
    author: "",
    publisher: "",
    sk_number: "",
  });

  const [activeFilters, setActiveFilters] = useState(filters);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);

    // KHUSUS untuk dropdown 'type', langsung picu pencarian
    if (name === "type") {
      setCurrentPage(1); // Reset halaman ke 1

      // Buat filter aktif baru dengan tipe yang baru & reset filter teks
      const newActiveFilters = {
        ...newFilters,
        title: "",
        author: "",
        publisher: "",
        sk_number: "",
      };

      setFilters(newActiveFilters);
      setActiveFilters(newActiveFilters);
    }
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    setActiveFilters(filters);
  };

  const fetchBooks = useCallback(
    async (page = 1) => {
      setLoading(true);

      const BASE_URL = `https://api.buku.kemdikbud.go.id/${activeFilters.type}/book`;

      const params = new URLSearchParams({
        code: "GuruSejahtera2025",
        page: page,
        limit: pageLimit,
      });

      const { type, ...otherFilters } = activeFilters;

      Object.keys(otherFilters).forEach((key) => {
        if (otherFilters[key]) {
          params.append(key, otherFilters[key]);
        }
      });

      const ENDPOINTS_URL = `${BASE_URL}?${params.toString()}`;
      console.log("REQUESTING API:", ENDPOINTS_URL);

      try {
        const response = await fetch(ENDPOINTS_URL);
        if (!response.ok) throw new Error("Gagal mengambil data dari API");

        const responseData = await response.json();
        setBooks(responseData.data || []);
        // Note: `totalRecords` biasanya dari `pagination.total`, bukan `total_pages`.
        // Namun saya biarkan sesuai kode asli Anda.
        setTotalRecords(responseData.pagination.total_pages);
      } catch (error) {
        console.error(error);
        setBooks([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    },
    [activeFilters, pageLimit]
  );

  useEffect(() => {
    fetchBooks(currentPage);
    scrollTop();
  }, [currentPage, fetchBooks]);

  const scrollTop = () => {
    document.getElementById("catalog")?.scrollIntoView();
  };

  return (
    <Layout>
      <section id="catalog">
        <div className="container px-3 py-5">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-12 col-lg-12 position-relative">
                  <h3 className="mb-3">Hasil Penilaian</h3>
                  <p>
                    Mari bersama menghadirkan{" "}
                    <span className="fw-bold">
                      {filters.type === "btp"
                        ? "Buku Teks Pendamping"
                        : "Buku Nonteks Pelajaran"}
                    </span>{" "}
                    yang lebih baik melalui buku-buku berkualitas, legal, dan
                    bermutu.
                  </p>
                  <div className="border border-1 rounded p-3">
                    <div className="row g-3">
                      <div className="col-md-2">
                        <label
                          htmlFor="type"
                          className="form-label fw-semibold small"
                        >
                          Tipe Buku
                        </label>
                        <select
                          id="type"
                          name="type"
                          className="form-select"
                          value={filters.type}
                          onChange={handleFilterChange}
                        >
                          <option value="btp">BTP</option>
                          <option value="bntp">BNTP</option>
                        </select>
                      </div>

                      <div className="col-md-3">
                        <label
                          htmlFor="title"
                          className="form-label fw-semibold small"
                        >
                          Judul
                        </label>
                        <input
                          id="title"
                          name="title"
                          value={filters.title}
                          onChange={handleFilterChange}
                          type="text"
                          className="form-control"
                          placeholder="Cth: Buku Siswa"
                        />
                      </div>

                      <div className="col-md-3">
                        <label
                          htmlFor="author"
                          className="form-label fw-semibold small"
                        >
                          Penulis
                        </label>
                        <input
                          id="author"
                          name="author"
                          value={filters.author}
                          onChange={handleFilterChange}
                          type="text"
                          className="form-control"
                          placeholder="Cth: Sardianto"
                        />
                      </div>

                      <div className="col-md-2">
                        <label
                          htmlFor="publisher"
                          className="form-label fw-semibold small"
                        >
                          Penerbit
                        </label>
                        <input
                          id="publisher"
                          name="publisher"
                          value={filters.publisher}
                          onChange={handleFilterChange}
                          type="text"
                          className="form-control"
                          placeholder="Cth: Thursina"
                        />
                      </div>

                      <div className="col-md-2">
                        <label
                          htmlFor="sk_number"
                          className="form-label fw-semibold small"
                        >
                          SK Kelayakan
                        </label>
                        <input
                          id="sk_number"
                          name="sk_number"
                          value={filters.sk_number}
                          onChange={handleFilterChange}
                          type="text"
                          className="form-control"
                          placeholder="044/H/P/2024"
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSearchClick}
                      >
                        <FontAwesomeIcon icon={faSearch} /> Cari Buku
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {loading ? (
                  [...Array(6)].map((item, index) => (
                    <div key={index} className="col-lg-4 my-2">
                      <CardSkeleton />
                    </div>
                  ))
                ) : books.length === 0 ? (
                  <div className="text-center mt-5">
                    <img
                      width="60"
                      src="/assets/image/catalog/not-found.png"
                      className="img-fluid"
                      alt="Not found"
                    />
                    <div className="text-center mt-2">
                      Buku tidak ditemukan atau belum tersedia
                    </div>
                  </div>
                ) : (
                  books.map((book, index) => (
                    <div key={index} className="col-lg-4 my-2">
                      <Link
                        to={`/hasil-penilaian/${book.id}?type=${filters.type}`}
                        className="text-decoration-none text-dark"
                      >
                        <CardBook
                          image={book.cover_image}
                          title={book.title}
                          typeBook={"pdf"}
                          level={book.school_level?.name}
                        />
                      </Link>
                    </div>
                  ))
                )}
              </div>
              <div className="mt-4">
                <Paginator
                  pagePrevText={<FontAwesomeIcon icon={faArrowLeft} />}
                  pageNextText={<FontAwesomeIcon icon={faArrowRight} />}
                  totalRecords={totalRecords}
                  pageLimit={pageLimit}
                  pageNeighbours={2}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default HasilPenilaian;
